import { ShippingService } from './../shipping-service/shipping-service.entity';
import { BaseDto } from '../../core';
import { CouponNames, CouponSetting } from './coupon-setting.entity';
import { Brand, Buyer, Cart, CouponSettingUsableType, Product, PurchaseOrder } from '..';
import { COUPON_STATUS, COUPON_USABLE_TYPE, PRODUCT_SHIPPING_TYPE } from '../../shared';
import { DisplayCategory } from '../display-category';
import { Utils } from '../../common';
export class BuyerCoupon extends BaseDto<BuyerCoupon> {
  // cartIds: number[];
  discount: number;

  id: number;
  couponSettingId: number;
  buyerId: number;
  orderNumber: number;
  started: Date;
  ended: Date;
  couponStatus: COUPON_STATUS;
  created: Date;
  buyer: Buyer;
  couponSetting: CouponSetting;
  purchaseOrder?: PurchaseOrder;
  isUsable: boolean;

  isAvailable: boolean;
  sumItemPrice: number;
  sumCouponItemPrice: number;

  constructor(partial?: Partial<BuyerCoupon>) {
    super(partial);
  }

  setIsAvailable(selectedCarts: Cart[], shippingServiceId?: number) {
    let useCoupon = true;
    this.sumItemPrice = Utils.getUSDToFixed(
      selectedCarts.reduce((sum: number, cart: Cart) => {
        switch (this.couponSetting.couponUsableType) {
          case COUPON_USABLE_TYPE.ALL:
            return sum + cart.totalSalePriceUSD;
          case COUPON_USABLE_TYPE.DOWNLOAD:
            return sum + cart.totalSalePriceUSD;
          case COUPON_USABLE_TYPE.BRAND:
            return this.isIncludeBrand(this.couponSetting.couponSettingUsableTypes, cart)
              ? sum + cart.totalSalePriceUSD
              : sum;
          case COUPON_USABLE_TYPE.UQUICK:
            if (cart.shippingType === 'GENERAL') {
              // 일반상품 포함되면 유퀵 사용 불가
              useCoupon = false;
            }
            return cart.shippingType === PRODUCT_SHIPPING_TYPE.ROCKET ? sum + cart.totalSalePriceUSD : sum;
          case COUPON_USABLE_TYPE.PRODUCT:
            return this.isIncludeProduct(this.couponSetting.couponSettingUsableTypes, cart)
              ? sum + cart.totalSalePriceUSD
              : sum;
          case COUPON_USABLE_TYPE.CATEGORY:
            return this.isIncludeDisplayCategory(this.couponSetting.couponSettingUsableTypes, cart)
              ? sum + cart.totalSalePriceUSD
              : sum;
          case COUPON_USABLE_TYPE.SHIPPING:
            return this.isIncludeShippingService(this.couponSetting.couponSettingUsableTypes, shippingServiceId)
              ? sum + cart.totalSalePriceUSD
              : sum;
        }
      }, 0)
    );
    this.sumCouponItemPrice = Utils.getUSDToFixed(
      selectedCarts.reduce((sum: number, cart: Cart) => {
        switch (this.couponSetting.couponUsableType) {
          case COUPON_USABLE_TYPE.UQUICK:
            return this.excludeBrand(this.couponSetting.couponSettingUsableTypes, cart)
              ? sum
              : sum + cart.totalSalePriceUSD;
        }
      }, 0)
    );
    if (useCoupon) {
      this.isAvailable = this.sumItemPrice >= this.couponSetting.minPurchasePrice;
    } else {
      this.isAvailable = false;
    }
  }

  isIncludeBrand(couponSettingUsableTypes: CouponSettingUsableType[], cart: Cart) {
    const has = couponSettingUsableTypes.filter(
      (couponSettingUsableType) => couponSettingUsableType.brand.id === cart.mapperSaleProduct.productOption.brandId
    );
    return has.length;
  }

  excludeBrand(couponSettingUsableTypes: CouponSettingUsableType[], cart: Cart) {
    const has = couponSettingUsableTypes.filter(
      (couponSettingUsableType) =>
        couponSettingUsableType.excludeBrand.id === cart.mapperSaleProduct.productOption.brandId &&
        cart.shippingType === PRODUCT_SHIPPING_TYPE.ROCKET
    );

    return has.length;
  }

  isIncludeProduct(couponSettingUsableTypes: CouponSettingUsableType[], cart: Cart) {
    const has = couponSettingUsableTypes.filter(
      (couponSettingUsableType) => couponSettingUsableType.product.id === cart.mapperSaleProduct.productId
    );
    return has.length;
  }

  isIncludeDisplayCategory(couponSettingUsableTypes: CouponSettingUsableType[], cart: Cart) {
    const has = couponSettingUsableTypes.filter((couponSettingUsableType) =>
      cart.mapperSaleProduct.product.mapperDisplayCategoryProducts.some(
        (categoryProduct) => categoryProduct.displayCategory.id === couponSettingUsableType.displayCategory.id
      )
    );
    return has.length;
  }

  isIncludeShippingService(couponSettingUsableTypes: CouponSettingUsableType[], shippingServiceId?: number) {
    const has = couponSettingUsableTypes.filter((couponSettingUsableType) => {
      if (shippingServiceId) {
        // tslint:disable-next-line: no-unused-expression
        shippingServiceId === couponSettingUsableType.referenceId;
      }
    });
    return has.length;
  }
}
